import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getClientMessageDetails } from "../../../apis";
import ErrorAnimationComponent from "../../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import Loader from "../../../Components/Loader";
import PageTitle from "../../../Components/UI/PageTitle";
import HeaderMessagesComponent from "../../../Components/MessagesComponent/HeaderMessagesComponent";
import MessageContent from "../../../Components/MessagesComponent/MessageContent";
import MessageRepliers from "../../../Components/MessagesComponent/MessageRepliers";

const MessageDetails = () => {
  const [data, setData] = useState({});
  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const { messageId } = useParams();

  useEffect(() => {
    setIsLoading(true);
    getClientMessageDetails(messageId)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.log(error);
        setIsError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [messageId]);

  const {
    userImage,
    messageBy,
    createdAt,
    status,
    messageType,
    messageDetails,
    messageImage,
    messageTitle,
  } = data;

  if (isLoading) return <Loader />;
  if (isError) return <ErrorAnimationComponent message={isError} />;
  return (
    <>
      <PageTitle title={"Message Details"} />
      <div className="tw-wrapper tw-pt-4 tw-flex tw-flex-col tw-items-center">
        <article className="tw-shadow-xl tw-mb-4 tw-break-inside tw-py-2 tw-px-4 tw-rounded-xl tw-text-black tw-bg-white tw-flex tw-flex-col tw-bg-clip-border tw-w-full">
          <HeaderMessagesComponent
            userImage={userImage}
            messageBy={messageBy}
            createdAt={createdAt}
            status={status}
            messageType={messageType}
          />
          <p className="!tw-my-3 tw-w-[70%] tw-h-[1px] tw-shadow-[0_4px_4px_0_#00000040] tw-mx-auto tw-bg-secondary/50"></p>

          <MessageContent
            messageDetails={messageDetails}
            messageImage={messageImage}
            messageTitle={messageTitle}
            messageType={messageType}
          />
        </article>
        <MessageRepliers />
      </div>
    </>
  );
};

export default MessageDetails;
